import { DragEvent } from 'react'

import { IForm } from 'core-components/classes/models/IForm'

import styles from '../ItemsLine.module.scss'
import { IImmutable, IRowState } from '../models/IItemsLine'

export const addDragMultiSelect = (
  immutable: IImmutable,
  rowState: IRowState,
  pk: IForm | string,
  index: number,
  values: IForm[],
  setDragged: (value: boolean) => void,
  setValues?: (value: string[], items: IForm[]) => void,
  caption?: string
) => {
  const addClass = (current: string, add: string): string => {
    if (current.indexOf(add) > -1) {
      return current
    }
    return `${current} ${add}`
  }
  const removeClass = (current: string, add: string): string => {
    return current.replace(` ${add}`, '').replace(`${add}`, '')
  }
  return {
    draggable: true,
    onDragOver: (e: DragEvent<HTMLDivElement>) => {
      e.preventDefault()
      if (immutable.destination && immutable.destination !== e.target) {
        immutable.destination.className = removeClass(
          immutable.destination.className,
          styles['destination--show']
        )
      }
      const target = e.target as HTMLDivElement

      immutable.destination = target
      immutable.offsetLeftDestination = immutable.destination.offsetLeft
      target.className = addClass(target.className, styles['destination--show'])
    },

    onDragLeave: () => {
      if (!rowState.dragged) {
        if (!immutable.destination) {
          return
        }
        immutable.destination = null
      }
    },
    onDragStart: (e: DragEvent<HTMLDivElement>) => {
      immutable.source = e.target as HTMLDivElement
      immutable.offsetLeftSource = immutable.source.offsetLeft
      immutable.delta = e.clientX - immutable.source.offsetLeft - e.nativeEvent.offsetX
      immutable.who = pk
      rowState.dragged = true
      setTimeout(() => {
        if (immutable.source) {
          immutable.source.className = addClass(immutable.source.className, styles.hide)
        }
      }, 0)
      setDragged(true)
    },
    onDragEnd: () => {
      rowState.dragged = false
      if (immutable.source) {
        immutable.source.className = removeClass(immutable.source.className, styles.hide)
      }
      if (immutable.destination) {
        immutable.destination.className = removeClass(
          immutable.destination.className,
          styles['destination--show']
        )
      }
    },
    onDrop: () => {
      const id = immutable.who
      let positionDrag
      if (!immutable.past) {
        return
      }
      if (caption && id) {
        const indexDrag = values.findIndex((el) => el[caption] === id[caption])
        if (index === indexDrag) {
          positionDrag = index
        } else if (immutable.past === 'before') {
          positionDrag = index < indexDrag ? index : index - 1
        } else {
          positionDrag = index > indexDrag ? index : index + 1
        }
        const filteredItems = values.filter((el) => el[caption] !== id[caption])
        const result = [
          ...filteredItems.slice(0, positionDrag),
          id,
          ...filteredItems.slice(positionDrag),
        ]
        if (setValues) {
          setValues(
            result.map((el) => el[caption]),
            result as IForm[]
          )
        }
      }
      setDragged(false)
    },
  }
}
